
import React from "react";
import { Label } from "@/components/ui/label";
import NumericInput from "@/components/ui/NumericInput";
import { formatCurrency, parseCurrency } from "../../utils/formatters";
import { MetricTooltip } from "../../advanced/analytics/MetricTooltip";

interface ClosingCostItemProps {
  label: string;
  value: number;
  disabled?: boolean;
  onChange: (value: number) => void;
  isWaived?: boolean;
  builderName?: string;
  tooltipKey?: string;
}

const ClosingCostItem: React.FC<ClosingCostItemProps> = ({ 
  label, 
  value, 
  disabled = false, 
  onChange,
  isWaived = false,
  builderName,
  tooltipKey
}) => {
  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-2">
        <Label className={`text-sm font-medium ${isWaived ? 'line-through text-muted-foreground' : ''}`}>
          {label} {tooltipKey && <MetricTooltip metric={tooltipKey} />}
        </Label>
        {isWaived && (
          <div className="flex items-center gap-1">
            <span className="text-xs bg-green-100 text-green-800 px-2 py-1 rounded-full">
              WAIVED
            </span>
            {builderName && (
              <span className="text-xs text-muted-foreground">
                by {builderName}
              </span>
            )}
          </div>
        )}
      </div>
      <NumericInput 
        value={value}
        onChange={onChange}
        formatValue={formatCurrency}
        parseValue={parseCurrency}
        min={0}
        max={999999}
        disabled={disabled}
        className="w-24"
        inputClassName={`text-right ${isWaived ? 'line-through text-muted-foreground' : ''}`}
        prefix="$"
      />
    </div>
  );
};

export default ClosingCostItem;
